import { createNamespacedHelpers } from 'vuex';

const { mapState: mapStateGoogleServices } = createNamespacedHelpers('googleServices');

export default {
    computed: {
        ...mapStateGoogleServices({
            registeredDoubleClickSlots: state => state.doubleClickSlots,
        }),
        allNeededDoubleClickSlotsAvailable() {
            return this.doubleClickSlots.every(slot => this.registeredDoubleClickSlots.findIndex(stateSlot => stateSlot.id === slot.id) >= 0);
        },
    },
    methods: {
        watchOnce({ key, callback }) {
            const unwatch = this.$watch(key, (value, oldValue) => {
                callback(value, oldValue, unwatch);
            });
        },
    },
    watch: {
        allNeededDoubleClickSlotsAvailable(currentState) {
            if (currentState) {
                window.googletag.cmd.push(() => {
                    this.registeredDoubleClickSlots.forEach(({ gptSlot }) => {
                        gptSlot.addService(window.googletag.pubads());
                    });
                });
                window.googletag.pubads().collapseEmptyDivs();
                window.googletag.pubads().enableSingleRequest();
                window.googletag.pubads().enableLazyLoad({
                    fetchMarginPercent: 100,
                    renderMarginPercent: 100,
                    mobileScaling: 2.0,
                });
                window.googletag.pubads().setTargeting('Enviro', ['prod']);
                window.googletag.enableServices();
                window.googletag.cmd.push(() => {
                    this.registeredDoubleClickSlots.forEach(({ gptSlot }) => {
                        window.googletag.display(gptSlot);
                    });
                });
            }
        },
    },
};
